// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1irLI","left":"styles_left__2v6lh","desktopActions":"styles_desktopActions__e7o0F","title":"styles_title__3SzSn"};